import { useState, useEffect } from 'react';
import { tableHeader, tableData, title, btnOneNoWidth } from '../utils/style';
import AddMobileVan from '../modals/AddMobileVan';
import { url } from "../utils/config";
import axios from "axios";
import Table from '../reusable_components/Table';
import Button from '../reusable_components/Button';
import moment from 'moment';

function MobileVans() {
    const [ showAddVan, setShowAddVan ] = useState(false)
    const [ reloadTable, setReloadTable ] = useState(false)

    const options = [
        {
            header: 'Make',
            key: 'make',
        },
        {
            header: 'Model',
            key: 'model',
        },
        {
            header: 'Registration Date',
            key: 'registrationDate',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'Maintainence Schedule',
            key: 'maintainenceSchedule',
        },
        {
            header: 'Age',
            key: 'age'
        },
        {
            header: 'Insurance',
            jey: 'insurance'
        },
        {
            header: 'Incidence',
            key: 'incidence'
        },
        {
            header: 'Assigned To',
            key: 'assignedTo'
        }
    ]

    const excludeFilter = ['Maintainence Schedule', 'Insurance', 'Incidence', 'Assigned To', 'Age']


    return(
        <div className="p-4">
            {
                showAddVan && <AddMobileVan setShowModal={setShowAddVan} reload={setReloadTable}/>
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Mobile Vans</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Mobile Van`} clickHandler={() => setShowAddVan(!showAddVan)} />
                )}
            </div>
            <Table 
                options={options} 
                url={url + '/mobile_vans'} 
                pagination 
                clickHandler={() => setShowAddVan(!showAddVan)}
                btnTitle={'Mobile Van'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default MobileVans;